var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobile-list-ad"},_vm._l((_vm.list),function(item){return _c('Link',{key:item.id,staticClass:"item",attrs:{"to":item.link,"target":item.target}},[_c('img',{attrs:{"src":require(("~/assets/" + (item.imgUrl)))}})])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }